import { render, staticRenderFns } from "./ListingsSold.vue?vue&type=template&id=1ed2709e&scoped=true&"
import script from "./ListingsSold.vue?vue&type=script&lang=ts&"
export * from "./ListingsSold.vue?vue&type=script&lang=ts&"
import style0 from "./ListingsSold.vue?vue&type=style&index=0&id=1ed2709e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2709e",
  null
  
)

export default component.exports